import { useOutletContext } from "react-router-dom"

import { ROLES } from "@components/Domain"
import { useAppContext } from "@components/AppContext"
import {
  sendDistributionPendingApprovalNotificationOperation as createNotificationOperation
} from "@api/services/notifications"


const useSendNotifications = () => {
  const { request } = useAppContext()
  const { project, activeApprovers } = useOutletContext()

  const { id: projectId } = project

  const activeApproversOnly = activeApprovers
    .filter(({ roles }) => roles.includes(ROLES.APPROVER))

  return async () => {
    for (const user of activeApproversOnly) {
      const { email: toAddress } = user

      const mutation = { toAddress, projectId }

      await request(createNotificationOperation, { mutation })
    }
  }
}

export default useSendNotifications
